// Import the necessary functions from Vue
import { ref, onMounted } from "vue";
// Import axios to perform HTTP requests
import axios from "axios";

// Define a composition function to fetch data
export function useGetData(url) {
  // Create a reactive ref to store the fetched data
  const data = ref(null);
  // Create a reactive ref to store error messages
  const error = ref(null);

  // Function to fetch data from the provided URL
  const fetchData = async () => {
    try {
      // Fetch data from the provided URL using axios
      const response = await axios.get(url);
      // Update the data ref with the fetched data
      data.value = response.data;
      // console.log("data", response);
    } catch (err) {
      // If an error occurs, set the error ref with the error message
      error.value = err.message;
    } finally {
      // Remove the loading state
    }
  };

  // Call the fetchData function when the component is mounted
  onMounted(() => {
    fetchData();
  });

  // Return the reactive refs and fetchData function for use in components
  return { data, error, fetchData };
}
